import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  isNonEmptyString,
  isNumeric,
  createCustomPropType,
} from '../../../../js/app/react/validators';
import Navigation from '../../Navigation/NavigationContainer';
import Validation from '../../Validation/ValidationContainer';
import AdvWorkflowStep from '../../AdvWorkflowStep/AdvWorkflowStepContainer';
import { BACKEND_KEY } from '../TaxesWorkflowConstants';
import AdvForm from '../../../CommonComponents/AdvForm';
import {
  inputTextChanged,
  simpleSelectChanged,
} from '../../../Profile/Accounts_react/AccountsUtils';
import { validateAndStoreTaxesLocation } from '../TaxesWorkflowValidator';
import workflowAnalyticsEvents from '../../AnalyticsWorkflow/AnalyticsWorkflow';
import taxesLocationShouldSkip from './TaxesLocationShouldSkip';
import SimpleSelect from '../../SimpleSelect/SimpleSelectView';

class TaxesLocationView extends Component {
  componentDidUpdate({ isPopulated: previousIsPopulated }) {
    const {
      clientId,
      workflowId,
      preprocessData,
      store2,
      serverTaxesLocation,
      isPopulated,
    } = this.props;

    if (!previousIsPopulated && isPopulated) {
      preprocessData(clientId, serverTaxesLocation, store2(workflowId));
    }
  }

  render() {
    const {
      branch,
      workflowId,
      clientId,
      taxesLocation,
      taxesLocationOptions,
      taxesLocationGroups,
      store,
      store2,
      hasPartner,
      hasFamily,
      isGoingForward,
    } = this.props;
    const dropdownValueObj =
      taxesLocationOptions.find(option => option.value === taxesLocation) || {};

    return (
      <AdvWorkflowStep
        branch={branch}
        workflowId={workflowId}
        canSkip={taxesLocationShouldSkip(isGoingForward, taxesLocation)}
      >
        <Validation workflowId={workflowId} validationId={`${BACKEND_KEY}.TaxesLocation`} />

        <h2>Where {hasFamily ? 'does your family' : 'do you'} currently file taxes?</h2>
        <AdvForm className="adv-workflow-responsive-form">
          <ul className="horizontal">
            <li>
              <SimpleSelect
                placeholder="State"
                id="adv-tax-state"
                className="no-horizontal-scroll md"
                value={dropdownValueObj}
                isLeftAligned
                options={taxesLocationOptions}
                groups={taxesLocationGroups}
                onValueChange={simpleSelectChanged(
                  clientId,
                  store2(workflowId),
                  `${BACKEND_KEY}.Taxes.FilingState`,
                )}
              />
            </li>
          </ul>
        </AdvForm>
        <Navigation
          nextIterators={[]}
          dirtyGraphNodes={[]}
          validator={validateAndStoreTaxesLocation(
            taxesLocation,
            hasPartner,
            inputTextChanged(clientId, store(workflowId), `${BACKEND_KEY}.Taxes.FilingState`),
            inputTextChanged(clientId, store(workflowId), `${BACKEND_KEY}.Taxes.FilingStatus`),
          )}
          validationId={`${BACKEND_KEY}.TaxesLocation`}
          workflowId={workflowId}
          backendKey={BACKEND_KEY}
          validatedOnClick={() => workflowAnalyticsEvents(workflowId, 'tax_completed')}
        />
      </AdvWorkflowStep>
    );
  }
}

TaxesLocationView.defaultProps = {
  taxesLocation: null,
  hasPartner: false,
  hasFamily: false,
};

TaxesLocationView.propTypes = {
  isPopulated: PropTypes.bool.isRequired,
  branch: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  workflowId: createCustomPropType(isNonEmptyString).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  store: PropTypes.func.isRequired,
  hasPartner: PropTypes.bool,
  hasFamily: PropTypes.bool,
  store2: PropTypes.func.isRequired,
  preprocessData: PropTypes.func.isRequired,
  taxesLocation: PropTypes.string,
  serverTaxesLocation: PropTypes.number.isRequired,
  isGoingForward: PropTypes.bool.isRequired,
  taxesLocationOptions: PropTypes.arrayOf(PropTypes.shape(PropTypes.string)).isRequired,
  taxesLocationGroups: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default TaxesLocationView;
